var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".abea5cb8-c3e0-4043-87f2-801b6c7569cf{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}.e059e6f3-0379-488e-86d8-b58cabca862d{fill:currentColor;}")),React.createElement("g",{"id":"a2ad2339-aa18-4d19-8f92-a30e3a088953","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b19bc938-0f0d-49a9-9f5c-d62932c060fa","data-name":"Layer 1"},[React.createElement("line",{"className":"abea5cb8-c3e0-4043-87f2-801b6c7569cf","y1":"8.178","x2":"27.831","y2":"8.178","key":0}),React.createElement("polygon",{"className":"e059e6f3-0379-488e-86d8-b58cabca862d","points":"21.204 16.357 19.84 14.893 27.063 8.18 19.84 1.465 21.204 0 30 8.18 21.204 16.357","key":1})]))]);
}

LinkArrow.defaultProps = {"width":"30","height":"16.357","viewBox":"0 0 30 16.357"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
